<template>
  <div class="default-layout">
    <div class="default-layout__sidebar-wrapper">
      <AppSidebar
        class="default-layout__sidebar"
        logo="/images/logo.svg"
        profileLink="/profile"
        :username="user.fullname"
        :userPhoto="user.photo"
        :userPost="user.post"
        :nav="nav"
        :active="$route.path"
      />
    </div>

    <div class="default-layout__content">
      <div class="default-layout__container">
        <slot />
      </div>
    </div>

    <AppLoading
      v-if="$store.getters['loading/load']"
    />
  </div>
</template>

<script>
import AppSidebar from '@/components/AppSidebar'
import AppLoading from '@/components/AppLoading'

export default {
  name: 'default',
  components: {
    AppLoading,
    AppSidebar
  },
  computed: {
    user () {
      const {
        name,
        surname,
        photo,
        post
      } = this.$store.getters['auth/loggedInUser']

      return {
        fullname: `${name} ${surname}`,
        photo,
        post
      }
    },
    nav () {
      return this.$store.getters['sidebar/menu']
    }
  },
  async created () {
    if (this.$store.getters['auth/isAuthenticated']) {
      await this.$store.dispatch('auth/fetchUser')
    }
  }
}
</script>

<style lang="scss">
.default-layout {
  display: flex;
  overflow: hidden;

  &__sidebar-wrapper {
    width: 260px;
    height: 100vh;
    flex-shrink: 0;
  }
  &__sidebar {
    height: 100vh;
  }
  &__content {
    padding: 68px 20px 68px 100px;
    flex-grow: 1;
    position: relative;
    max-height: 100vh;
    overflow: auto;

    & > div {
      min-height: 100%;
    }
  }

  &__container {
    max-width: 1200px;
    margin: 0 auto;
  }
}
</style>
